import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import ChangeRow from './changeRow';

/**
 * A field-level change recorded against the Workkard.
 *
 * The field label and its old/new values arrive on the entry itself. They used
 * to be fetched per row from /cvl when the row was expanded, which meant one
 * request per visible log line.
 */
export default function WorkkardLog({ data }) {
    return (
        <div className="combinedListing detailListing">
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>
            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                <div className="combinedDescription detailDescription">
                    <div className="alignMiddle mb mb__8 flexWrap">
                        <ActorName userId={data.actor_id} inner="header" />
                        <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                        </span>
                        edited workkard
                    </div>
                    <div className="update_information">
                        <ul className="logs_listing">
                            <ChangeRow change={data.change} />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
